import { cbSemanticCssVars, typographyCss, colors } from '@creditornot/cb-ingredients';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type DocumentDropzoneProps = {
  documentFileName?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  onSelectFile: (file: File) => void;
};

const DropzoneArea = styled.div<{ dragActive: boolean }>`
  ${typographyCss.Body3()}
  align-items: center;
  border-radius: 8px;
  border: 2px dashed ${({ dragActive }) => (dragActive ? colors.wolt100 : cbSemanticCssVars.borderPrimary)};
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 80px;
  width: 100%;
  padding: 30px;

  &:focus {
    border-color: ${colors.wolt100};
    outline: none;
  }
`;

const PromptAction = styled(T.Body3)`
  color: ${colors.wolt100};
`;

const Prompt = () => {
  return (
    <FormattedMessage
      id="compliance.kyb.file-upload.choose-or-drop"
      values={{ action: chunks => <PromptAction>{chunks}</PromptAction> }}
    />
  );
};

export const DocumentDropzone = ({ documentFileName, inputProps, onSelectFile }: DocumentDropzoneProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/png': [],
      'image/jpeg': [],
      'image/heic': [],
      'image/heif': [],
      'application/pdf': [],
    },
    useFsAccessApi: false,
    multiple: false,
    onDropAccepted: async (files: File[]) => {
      const [file] = files;

      if (!file) {
        return;
      }

      onSelectFile(file);
    },
  });

  return (
    <DropzoneArea {...getRootProps()} dragActive={isDragActive}>
      <input {...getInputProps()} {...inputProps} />

      <span>{documentFileName || <Prompt />}</span>
    </DropzoneArea>
  );
};
